import React, { useState, useRef, useEffect } from "react";
import "../styles/Home.css";

const Home = () => {
  const [language, setLanguage] = useState("fr");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const translations = {
    en: {
      navWelcome: "Home",
      navAbout: "About",
      navHistory: "History",
      navServices: "Services",
      navReservation: "Contact",
      heroTitle: "Lausanne Taxi Express.",
      heroTagline: "Bienvenue à bord",
      heroDesc: "Fast, safe, and reliable rides across Lausanne—anytime you need.",
      callNow: "Call WhatsApp",
      bookTaxi: "Book Taxi",
      fastPickup: "⚡ Fast Pickup",
      fastPickupDesc: "We arrive in minutes anywhere in Lausanne",
      safeRide: "🛡 Safe Ride",
      safeRideDesc: "Professional and trusted drivers",
      bestPrice: "💰 Best Price",
      bestPriceDesc: "Affordable and transparent pricing",
      aboutTitle: "About Us",
      aboutSubtitle: "Lausanne Taxi Express",
      aboutText: "Lausanne Taxi Express offers high-quality passenger transport services designed for comfort, reliability, and efficiency. From airport transfers to business travel and everyday trips, we ensure a smooth and professional experience for both individuals and corporate clients.",
      commitment: "Our commitment is to deliver flexible, customer-focused service with the highest standards of comfort and safety.",
      quality: "We deliver high-quality service with modern, well-equipped vehicles, competitive pricing, and a complete transport solution tailored to your needs.",
      feelFree: "Feel free to call us:",
      historyTitle: "Our History",
      historyText: "Lausanne Taxi Express was founded over a decade ago with a clear mission: to provide reliable, comfortable, and high-quality transport across Lausanne. Starting with a single vehicle, we have grown into a trusted fleet serving a diverse range of clients every day. Through professionalism and a strong commitment to customer satisfaction, we continue to deliver safe, punctual, and dependable journeys.",
      statVehicles: "🚖 50+ Vehicles",
      statRating: "⭐ 4.9/5 Rating",
      statYears: "🏆 10+ Years",
      statService: "🌍 24/7 Service",
      servicesTitle: "Our Services.",
      parcelDelivery: "Parcel delivery",
      parcelDesc: "Fast parcel delivery service, guaranteeing security and punctuality. Ideal for your urgent or valuable shipments.",
      schoolCourse: "School course",
      schoolDesc: "Daily school-to-home transport for your children, combining safety and reliability. Confidence and peace of mind for parents.",
      customerTransfer: "Customer transfer",
      customerDesc: "Roadside assistance and transfers for breakdown and insurance companies, with efficiency and comfort for your customers.",
      vipTransfer: "VIP Transfer",
      vipDesc: "Supreme comfort and privacy. Premium service for your travels.",
      medicalTransport: "Transport of medical equipment",
      medicalDesc: "Maximum reliability, careful handling. Guaranteed safety for your equipment.",
      excursions: "Excursions",
      excursionsDesc: "Personalized adventures, guaranteed discovery. Unforgettable escape to exceptional locations.",
      chatHelp: "💬 Need help? Chat with us",
      reservationTitle: "Contact form",
      reservationNote: "Please fill out the form below and we will get back to you shortly.",
      fullName: "Full name *",
      fullNamePlaceholder: "Your full name",
      phone: "Phone number *",
      phonePlaceholder: "Your phone number",
      email: "E-mail *",
      emailPlaceholder: "Your email address",
      dateLabel: "Date *",
      timeLabel: "Time *",
      bookingDetails: "Additional details",
      detailsPlaceholder: "Describe your request (pickup location, destination, passengers, etc.)",
      submitBtn: "Send Message",
      successMsg: "✓ Message sent! We'll get back to you shortly.",
      callUs: "Call us directly:",
      footerTagline: "Fast and secure transfers in the Lausanne area",
      quickLinks: "Quick Links",
      contact: "Contact",
      copyright: "All rights reserved.",
      brandName: "Lausanne Taxi Express",
      brandTagline: "Bienvenue à bord",
    },
    fr: {
      navWelcome: "Bienvenue",
      navAbout: "À propos",
      navHistory: "Historique",
      navServices: "Services",
      navReservation: "Contact",
      heroTitle: "Lausanne Taxi Express.",
      heroTagline: "Bienvenue à bord",
      heroDesc: "Transferts rapides et sécurisés dans la région lausannoise, divers trajets incluant rendez-vous d'affaires, transferts multiples.",
      callNow: "Appelez maintenant",
      bookTaxi: "Réserver un taxi",
      fastPickup: "⚡ Prise en charge rapide",
      fastPickupDesc: "Nous arrivons en quelques minutes partout à Lausanne",
      safeRide: "🛡 Trajet sécurisé",
      safeRideDesc: "Chauffeurs professionnels et de confiance",
      bestPrice: "💰 Meilleur prix",
      bestPriceDesc: "Tarifs abordables et transparents",
      aboutTitle: "À propos de nous",
      aboutSubtitle: "Lausanne Taxi Express",
      aboutText: "Lausanne Taxi Express est une société de transport de voyageurs qui vous accompagne au quotidien pour tous vos déplacements, que vous ayez besoin de vous rendre de chez vous ou du bureau à la gare ou à l'aéroport. Nous saurons répondre à vos besoins. Service de taxi pour les particuliers et les entreprises.",
      commitment: "Engagement : Adaptabilité, satisfaction client, confort et sécurité.",
      quality: "Qualité de service : Voitures haut de gamme, tarifs compétitifs et service complet.",
      feelFree: "N'hésitez pas à nous appeler :",
      historyTitle: "Notre histoire",
      historyText: "Fondé il y a plus d'une décennie, Lausanne Taxi Express a commencé avec un seul véhicule et une vision : fournir un transport premium et fiable dans la région lausannoise. Grâce à un dévouement à l'excellence et une approche centrée sur le client, nous sommes devenus une flotte de véhicules modernes et haut de gamme servant des milliers de clients satisfaits chaque année. Notre parcours continue avec l'innovation, des pratiques écologiques et un engagement inébranlable envers la ponctualité.",
      statVehicles: "🚖 50+ Véhicules",
      statRating: "⭐ Note 4.9/5",
      statYears: "🏆 10+ Années",
      statService: "🌍 Service 24/7",
      servicesTitle: "Nos services.",
      parcelDelivery: "Livraison de colis",
      parcelDesc: "Service de livraison rapide, garantissant sécurité et ponctualité. Idéal pour vos envois urgents ou précieux.",
      schoolCourse: "Transport scolaire",
      schoolDesc: "Transport quotidien domicile-école pour vos enfants, alliant sécurité et fiabilité. Confiance et tranquillité d'esprit pour les parents.",
      customerTransfer: "Transfert client",
      customerDesc: "Assistance routière et transferts pour les sociétés de dépannage et d'assurance, avec efficacité et confort pour vos clients.",
      vipTransfer: "Transfert VIP",
      vipDesc: "Confort et intimité suprêmes. Service premium pour vos voyages.",
      medicalTransport: "Transport de matériel médical",
      medicalDesc: "Fiabilité maximale, manipulation soigneuse. Sécurité garantie pour votre équipement.",
      excursions: "Excursions",
      excursionsDesc: "Aventures personnalisées, découverte garantie. Évasion inoubliable vers des lieux exceptionnels.",
      chatHelp: "💬 Besoin d'aide ? Discutez avec nous",
      reservationTitle: "Formulaire de contact",
      reservationNote: "Veuillez remplir le formulaire ci-dessous et nous vous répondrons rapidement.",
      fullName: "Nom complet *",
      fullNamePlaceholder: "Votre nom complet",
      phone: "Numéro de téléphone *",
      phonePlaceholder: "Votre numéro",
      email: "E-mail *",
      emailPlaceholder: "Votre adresse e-mail",
      dateLabel: "Date *",
      timeLabel: "Heure *",
      bookingDetails: "Détails supplémentaires",
      detailsPlaceholder: "Décrivez votre demande (lieu de prise en charge, destination, passagers, etc.)",
      submitBtn: "Envoyer le message",
      successMsg: "✓ Message envoyé ! Nous vous répondrons sous peu.",
      callUs: "Appelez-nous directement :",
      footerTagline: "Transferts rapides et sécurisés dans la région lausannoise",
      quickLinks: "Liens rapides",
      contact: "Contact",
      copyright: "Tous droits réservés.",
      brandName: "Lausanne Taxi Express",
      brandTagline: "Bienvenue à bord",
    },
    de: {
      navWelcome: "Willkommen",
      navAbout: "Über uns",
      navHistory: "Geschichte",
      navServices: "Dienstleistungen",
      navReservation: "Kontakt",
      heroTitle: "Lausanne Taxi Express.",
      heroTagline: "Bienvenue à bord",
      heroDesc: "Schnelle und sichere Transfers in der Region Lausanne, verschiedene Fahrten, einschließlich Geschäftstermine, Mehrfachtransfers.",
      callNow: "Jetzt anrufen",
      bookTaxi: "Taxi buchen",
      fastPickup: "⚡ Schnelle Abholung",
      fastPickupDesc: "Wir sind in wenigen Minuten überall in Lausanne",
      safeRide: "🛡 Sichere Fahrt",
      safeRideDesc: "Professionelle und vertrauenswürdige Fahrer",
      bestPrice: "💰 Bester Preis",
      bestPriceDesc: "Erschwingliche und transparente Preise",
      aboutTitle: "Über uns",
      aboutSubtitle: "Lausanne Taxi Express",
      aboutText: "Lausanne Taxi Express ist ein Personentransportunternehmen, das Sie täglich auf all Ihren Reisen begleitet, ob Sie von zu Hause oder vom Büro zum Bahnhof oder Flughafen reisen müssen. Wir werden gerne Ihre Bedürfnisse erfüllen. Taxidienst für Privatpersonen und Unternehmen.",
      commitment: "Engagement: Anpassungsfähigkeit, Kundenzufriedenheit, Komfort und Sicherheit.",
      quality: "Servicequalität: Hochwertige Autos, wettbewerbsfähige Preise und umfassender Service.",
      feelFree: "Rufen Sie uns an:",
      historyTitle: "Unsere Geschichte",
      historyText: "Vor über einem Jahrzehnt gegründet, begann Lausanne Taxi Express mit einem einzigen Fahrzeug und der Vision, premium und zuverlässigen Transport in der Region Lausanne anzubieten. Durch Hingabe an Exzellenz und einen kundenorientierten Ansatz sind wir zu einer Flotte moderner, hochwertiger Fahrzeuge gewachsen, die jährlich Tausende zufriedene Kunden bedienen. Unsere Reise setzt sich fort mit Innovation, umweltfreundlichen Praktiken und unerschütterlichem Engagement für Pünktlichkeit.",
      statVehicles: "🚖 50+ Fahrzeuge",
      statRating: "⭐ 4.9/5 Bewertung",
      statYears: "🏆 10+ Jahre",
      statService: "🌍 24/7 Service",
      servicesTitle: "Unsere Dienstleistungen.",
      parcelDelivery: "Paketzustellung",
      parcelDesc: "Schneller Paketzustellungsservice mit Garantie für Sicherheit und Pünktlichkeit. Ideal für dringende oder wertvolle Sendungen.",
      schoolCourse: "Schulbeförderung",
      schoolDesc: "Täglicher Schul-zu-Hause-Transport für Ihre Kinder, der Sicherheit und Zuverlässigkeit vereint. Vertrauen und Seelenfrieden für Eltern.",
      customerTransfer: "Kundentransfer",
      customerDesc: "Pannenhilfe und Transfers für Pannen- und Versicherungsunternehmen, effizient und komfortabel für Ihre Kunden.",
      vipTransfer: "VIP-Transfer",
      vipDesc: "Höchster Komfort und Privatsphäre. Premium-Service für Ihre Reisen.",
      medicalTransport: "Transport von medizinischen Geräten",
      medicalDesc: "Maximale Zuverlässigkeit, sorgfältige Handhabung. Garantierte Sicherheit für Ihre Ausrüstung.",
      excursions: "Ausflüge",
      excursionsDesc: "Personalisierte Abenteuer, garantierte Entdeckung. Unvergesslicher Ausflug zu außergewöhnlichen Orten.",
      chatHelp: "💬 Brauchen Sie Hilfe? Chatten Sie mit uns",
      reservationTitle: "Kontaktformular",
      reservationNote: "Bitte füllen Sie das untenstehende Formular aus und wir werden uns in Kürze bei Ihnen melden.",
      fullName: "Vollständiger Name *",
      fullNamePlaceholder: "Ihr vollständiger Name",
      phone: "Telefonnummer *",
      phonePlaceholder: "Ihre Telefonnummer",
      email: "E-Mail *",
      emailPlaceholder: "Ihre E-Mail-Adresse",
      dateLabel: "Datum *",
      timeLabel: "Uhrzeit *",
      bookingDetails: "Zusätzliche Details",
      detailsPlaceholder: "Beschreiben Sie Ihre Anfrage (Abholort, Ziel, Passagiere usw.)",
      submitBtn: "Nachricht senden",
      successMsg: "✓ Nachricht gesendet! Wir melden uns in Kürze bei Ihnen.",
      callUs: "Rufen Sie uns direkt an:",
      footerTagline: "Schnelle und sichere Transfers in der Region Lausanne",
      quickLinks: "Schnelllinks",
      contact: "Kontakt",
      copyright: "Alle Rechte vorbehalten.",
      brandName: "Lausanne Taxi Express",
      brandTagline: "Bienvenue à bord",
    },
    ar: {
      navWelcome: "الرئيسية",
      navAbout: "من نحن",
      navHistory: "تاريخنا",
      navServices: "خدماتنا",
      navReservation: "اتصل بنا",
      heroTitle: "لوزان تاكسي إكسبرس",
      heroTagline: "مرحباً بكم على متننا",
      heroDesc: "رحلات سريعة وآمنة وموثوقة في جميع أنحاء لوزان - في أي وقت تحتاجها.",
      callNow: "اتصل الآن",
      bookTaxi: "احجز تاكسي",
      fastPickup: "⚡ استلام سريع",
      fastPickupDesc: "نصل في دقائق إلى أي مكان في لوزان",
      safeRide: "🛡 رحلة آمنة",
      safeRideDesc: "سائقون محترفون وموثوقون",
      bestPrice: "💰 أفضل سعر",
      bestPriceDesc: "أسعار معقولة وشفافة",
      aboutTitle: "من نحن",
      aboutSubtitle: "لوزان تاكسي إكسبرس",
      aboutText: "تقدم لوزان تاكسي إكسبرس خدمات نقل ركاب عالية الجودة مصممة لتحقيق الراحة والموثوقية والكفاءة. من خدمات النقل من وإلى المطار إلى السفر التجاري والرحلات اليومية، نضمن تجربة سلسة ومهنية للأفراد والشركات على حد سواء.",
      commitment: "التزامنا هو تقديم خدمة مرنة تركز على العميل بأعلى معايير الراحة والسلامة.",
      quality: "نقدم خدمة عالية الجودة بأسطول من السيارات الحديثة المجهزة تجهيزاً جيداً، وأسعار تنافسية، وحل نقل متكامل مصمم خصيصاً لتلبية احتياجاتك.",
      feelFree: "لا تتردد في الاتصال بنا:",
      historyTitle: "تاريخنا",
      historyText: "تأسست لوزان تاكسي إكسبرس منذ أكثر من عقد بمهمة واضحة: توفير نقل موثوق ومريح وعالي الجودة في جميع أنحاء لوزان. بدأنا بسيارة واحدة ونمونا لنصبح أسطولاً موثوقاً يخدم مجموعة متنوعة من العملاء يومياً. من خلال الاحترافية والالتزام القوي برضا العملاء، نواصل تقديم رحلات آمنة وفي الوقت المحدد وموثوقة.",
      statVehicles: "🚖 ٥٠+ مركبة",
      statRating: "⭐ ٤.٩/٥ تقييم",
      statYears: "🏆 ١٠+ سنوات",
      statService: "🌍 خدمة ٢٤/٧",
      servicesTitle: "خدماتنا",
      parcelDelivery: "توصيل الطرود",
      parcelDesc: "خدمة توصيل سريعة للطرود تضمن الأمان والدقة. مثالية لشحناتك العاجلة أو الثمينة.",
      schoolCourse: "النقل المدرسي",
      schoolDesc: "نقل يومي من المنزل إلى المدرسة لأطفالك، يجمع بين السلامة والموثوقية. ثقة وراحة بال للآباء.",
      customerTransfer: "نقل العملاء",
      customerDesc: "مساعدة على الطريق ونقل لشركات الأعطال والتأمين، مع الكفاءة والراحة لعملائك.",
      vipTransfer: "نقل VIP",
      vipDesc: "راحة وخصوصية فائقة. خدمة ممتازة لأسفارك.",
      medicalTransport: "نقل المعدات الطبية",
      medicalDesc: "موثوقية قصوى، معالجة دقيقة. أمان مضمون لمعداتك.",
      excursions: "رحلات استكشافية",
      excursionsDesc: "مغامرات مخصصة، اكتشاف مضمون. هروب لا يُنسى إلى مواقع استثنائية.",
      chatHelp: "💬 بحاجة مساعدة؟ تحدث معنا",
      reservationTitle: "نموذج الاتصال",
      reservationNote: "يرجى ملء النموذج أدناه وسنعاود الاتصال بك قريباً.",
      fullName: "الاسم الكامل *",
      fullNamePlaceholder: "اسمك الكامل",
      phone: "رقم الهاتف *",
      phonePlaceholder: "رقم هاتفك",
      email: "البريد الإلكتروني *",
      emailPlaceholder: "بريدك الإلكتروني",
      dateLabel: "التاريخ *",
      timeLabel: "الوقت *",
      bookingDetails: "تفاصيل إضافية",
      detailsPlaceholder: "صف طلبك (مكان الاستلام، الوجهة، عدد الركاب، إلخ.)",
      submitBtn: "إرسال الرسالة",
      successMsg: "✓ تم إرسال الرسالة! سنعاود الاتصال بك قريباً.",
      callUs: "اتصل بنا مباشرة:",
      footerTagline: "نقل سريع وآمن في منطقة لوزان",
      quickLinks: "روابط سريعة",
      contact: "اتصل بنا",
      copyright: "جميع الحقوق محفوظة.",
      brandName: "لوزان تاكسي إكسبرس",
      brandTagline: "مرحباً بكم على متننا",
    }
  };

  const t = translations[language];
  const [formData, setFormData] = useState({ fullName: "", phone: "", email: "", date: "", time: "", details: "" });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const aboutRef = useRef(null);
  const historyRef = useRef(null);
  const servicesRef = useRef(null);
  const reservationRef = useRef(null);

  const handleInputChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleReservationSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.fullName || !formData.phone || !formData.email || !formData.date || !formData.time) {
      alert("Please fill in all required fields.");
      return;
    }

    // Build WhatsApp message
    const message = `*New Booking Request* 🚖

*Name:* ${formData.fullName}
*Phone:* ${formData.phone}
*Email:* ${formData.email}
*Date:* ${formData.date}
*Time:* ${formData.time}
*Details:* ${formData.details || "—"}`;

    const phoneNumber = "+41766152270";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    // Open WhatsApp
    window.open(url, "_blank");

    // Optional: reset form
    setFormData({
      fullName: "",
      phone: "",
      email: "",
      date: "",
      time: "",
      details: ""
    });
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 3000);
  };

  const scrollToSection = (ref) => {
    setMobileMenuOpen(false);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToTop = () => {
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleLanguageChange = (e) => setLanguage(e.target.value);

  const servicesData = [
    { title: t.parcelDelivery, desc: t.parcelDesc, icon: "📦" },
    { title: t.schoolCourse, desc: t.schoolDesc, icon: "🎓" },
    { title: t.customerTransfer, desc: t.customerDesc, icon: "👥" },
    { title: t.vipTransfer, desc: t.vipDesc, icon: "👑" },
    { title: t.medicalTransport, desc: t.medicalDesc, icon: "🏥" },
    { title: t.excursions, desc: t.excursionsDesc, icon: "🏞️" },
  ];

  useEffect(() => {
    if (language === 'ar') {
      document.body.style.direction = 'rtl';
    } else {
      document.body.style.direction = 'ltr';
    }
  }, [language]);

  return (
    <div className="home">
      <header className="header">
        <div className="container header-container">
          <div className="logo">
            <img src="/logo.jpeg" alt="Lausanne Taxi Express Logo" className="logo-icon" />
            <div className="logo-text">
              <h2>{t.brandName}</h2>
              <span className="logo-tagline">{t.brandTagline}</span>
            </div>
          </div>

          <button
            className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            <span></span><span></span><span></span>
          </button>

          <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <ul>
              <li><a href="#welcome" onClick={(e) => { e.preventDefault(); scrollToTop(); }}>{t.navWelcome}</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection(aboutRef); }}>{t.navAbout}</a></li>
              <li><a href="#history" onClick={(e) => { e.preventDefault(); scrollToSection(historyRef); }}>{t.navHistory}</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection(servicesRef); }}>{t.navServices}</a></li>
              <li><a href="#reservation" onClick={(e) => { e.preventDefault(); scrollToSection(reservationRef); }}>{t.navReservation}</a></li>
            </ul>
          </nav>

          <div className="header-right">
            <div className="language-dropdown">
              <select value={language} onChange={handleLanguageChange} className="lang-select">
                <option value="en">🇬🇧 English</option>
                <option value="fr">🇫🇷 Français</option>
                <option value="de">🇩🇪 Deutsch</option>
                <option value="ar">🇸🇦 العربية</option>
              </select>
            </div>
            <div className="header-contact">
              <a href="tel:+41766152270" className="phone-link">📞 +41 76 615 22 70</a>
              <a href="mailto:info@lausannetaxiexpress.com" className="email-link">✉️ info@lausannetaxiexpress.com</a>
            </div>
          </div>
        </div>
      </header>

      <section
        id="welcome"
        className="hero"
        style={{
          background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url('/t2.jpg') no-repeat center center/cover`
        }}
      >
        <div className="overlay">
          <h1>{t.heroTitle}</h1>
          <p className="hero-tagline">{t.heroTagline}</p>
          <p>{t.heroDesc}</p>
          <div className="buttons">         
            <button
              className="call"
              onClick={() => window.open("https://wa.me/+41766152270", "_blank")}
            >
              {t.callNow}
            </button>
            <button className="order" onClick={() => scrollToSection(reservationRef)}>{t.bookTaxi}</button>
          </div>
        </div>
      </section>

      <div className="features container">
        <div className="card"><h3>{t.fastPickup}</h3><p>{t.fastPickupDesc}</p></div>
        <div className="card"><h3>{t.safeRide}</h3><p>{t.safeRideDesc}</p></div>
        <div className="card"><h3>{t.bestPrice}</h3><p>{t.bestPriceDesc}</p></div>
      </div>

      <section ref={aboutRef} id="about" className="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>{t.aboutTitle}</h2>
              <h3>{t.aboutSubtitle}</h3>
              <p>{t.aboutText}</p>
              <div className="commitment">{t.commitment}</div>
              <div className="quality">{t.quality}</div>
              <div className="call-us"><p>{t.feelFree} <a href="tel:+41766152270">+41 76 615 22 70</a></p></div>
            </div>
            <div className="about-image">
              <img src="/t3.jpg" alt="Luxury taxi" />
            </div>
          </div>
        </div>
      </section>

      <section ref={historyRef} id="history" className="history-section">
        <div className="container">
          <h2>{t.historyTitle}</h2>
          <div className="history-content">
            <p>{t.historyText}</p>
            <div className="history-stats">
              <div className="stat">{t.statVehicles}</div>
              <div className="stat">{t.statRating}</div>
              <div className="stat">{t.statYears}</div>
              <div className="stat">{t.statService}</div>
            </div>
          </div>
        </div>
      </section>

      <section ref={servicesRef} id="services" className="services-section">
        <div className="container">
          <h2 className="section-title">{t.servicesTitle}</h2>
          <div className="services-grid">
            {servicesData.map((s, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="chat-help"><button className="chat-btn">{t.chatHelp}</button></div>
        </div>
      </section>

      <section ref={reservationRef} id="reservation" className="reservation-section">
        <div className="container">
          <h2 className="section-title">{t.reservationTitle}</h2>
          <div className="reservation-note"><p>{t.reservationNote}</p></div>
          <form className="reservation-form" onSubmit={handleReservationSubmit}>
            <div className="form-group">
              <label>{t.fullName}</label>
              <input
                type="text"
                name="fullName"
                placeholder={t.fullNamePlaceholder}
                value={formData.fullName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t.phone}</label>
              <input
                type="tel"
                name="phone"
                placeholder={t.phonePlaceholder}
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t.email}</label>
              <input
                type="email"
                name="email"
                placeholder={t.emailPlaceholder}
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t.dateLabel}</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t.timeLabel}</label>
              <input
                type="time"
                name="time"
                value={formData.time}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t.bookingDetails}</label>
              <textarea
                name="details"
                placeholder={t.detailsPlaceholder}
                rows="4"
                value={formData.details}
                onChange={handleInputChange}
              ></textarea>
            </div>

            <button type="submit" className="reservation-btn">
              {t.submitBtn}
            </button>
            {formSubmitted && <p className="success-msg">{t.successMsg}</p>}
          </form>
          <div className="reservation-contact">
            <p>
              {t.callUs}{" "}
              <a href="tel:+41766152270">+41 76 615 22 70</a>
              {" | "}
              <a
                href="https://wa.me/+41766152270"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#25D366", fontWeight: "bold" }}
              >
                WhatsApp Chat
              </a>
              {" | ✉️ "}
              <a href="mailto:info@lausannetaxiexpress.com">
                info@lausannetaxiexpress.com
              </a>
            </p>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container footer-container">
          <div className="footer-logo">
            <h3>🚖 {t.brandName}</h3>
            <p>{t.footerTagline}</p>
          </div>
          <div className="footer-links">
            <h4>{t.quickLinks}</h4>
            <ul>
              <li><a href="#welcome" onClick={(e) => { e.preventDefault(); scrollToTop(); }}>{t.navWelcome}</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection(aboutRef); }}>{t.navAbout}</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection(servicesRef); }}>{t.navServices}</a></li>
              <li><a href="#reservation" onClick={(e) => { e.preventDefault(); scrollToSection(reservationRef); }}>{t.navReservation}</a></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>{t.contact}</h4>
            <p>📞 <a href="tel:+41766152270">+41 76 615 22 70</a></p>
            <p>✉️ <a href="mailto:info@lausannetaxiexpress.com">info@lausannetaxiexpress.com</a></p>
            <p>📍 Lausanne, Switzerland</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Lausanne Taxi Express. {t.copyright}</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
